import React, { lazy, useEffect } from 'react';

import { type Route, type Routes } from 'react-resource-router';

import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const TwgLabsHome = lazy(
	() => import(/* webpackChunkName: "@atlaskit-internal_dtac-labs-home" */ '../../pages/labs/home'),
);

const TwgLabsHomeWithAccess: React.FC = () => (
	<AppAccessGate appName="Labs">
		<TwgLabsHome />
	</AppAccessGate>
);

const ROUTE_PREFIX = '/labs' as const;

const LegacyRedirect: React.FC = () => {
	useEffect(() => {
		// SPA-style redirect: update history and notify router
		window.history.replaceState({}, '', ROUTE_PREFIX);
		window.dispatchEvent(new PopStateEvent('popstate'));
	}, []);
	return null;
};

const twgLabsRoutesObject: Record<string, Route> = {
	home: {
		name: 'home',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(TwgLabsHomeWithAccess),
	},
	legacyRedirect: {
		name: 'legacy-redirect',
		path: '/playground',
		exact: true,
		component: LegacyRedirect,
	},
} as const;

export const labsRoutes: Routes = Object.values(twgLabsRoutesObject);
